import { render, staticRenderFns } from "./ViewRequests.vue?vue&type=template&id=d5434626"
import script from "./ViewRequests.vue?vue&type=script&lang=js"
export * from "./ViewRequests.vue?vue&type=script&lang=js"
import style0 from "./ViewRequests.vue?vue&type=style&index=0&id=d5434626&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports